import config from 'shared/config'
import { type Platforms } from 'shared/api/accounts'
import { type ThirdPartyProviders } from 'shared/thirdParty'
import { type SupportedPlatforms } from 'src/dataSource/types'

// Leaf module: `shared/config` is the only runtime import. `oauth.ts` and
// `constants/index.ts` sit inside an import cycle, so anything they evaluate at
// module load must not read bindings from that cycle.
const DASHBOARD_URL = config('NEXT_PUBLIC_DASHBOARD_URL') as string

export const generateOauthLoginUrl = (
  platformOrProvider: SupportedPlatforms | ThirdPartyProviders,
  thirdPartyPlatform?: Platforms,
  usePreparingPage?: boolean
): string => {
  if (thirdPartyPlatform != null) {
    if (usePreparingPage === true) {
      return `${DASHBOARD_URL}/thirdParty/${platformOrProvider}/${thirdPartyPlatform}/preparing`
    }
    return `${DASHBOARD_URL}/api/data-source/${platformOrProvider}/login/${thirdPartyPlatform}`
  }
  return `${DASHBOARD_URL}/api/data-source/oauth/login/${platformOrProvider}`
}
